import { useState } from 'react';
import { useAppContext } from '../../../Services/AppContext';
import { useRootWorkplaceByChildQuery } from '../../../graphql/graphql';

export default function useWorkplaceWorkers(
	getWorkplaceWorkersQuery: any,
	rootWorkplaceId?: string,
) {
	const [page, setPage] = useState(1);
	const getWorkplaceWorkers = (filter: object) => {
		getWorkplaceWorkersQuery({
			...filter,
			skip: (page - 1) * 48,
			rootWorkplaceId: rootWorkplaceId,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getWorkplaceWorkers, getNextPage, page, setPage };
}
